import React from 'react';
import {
  EmployerAgents,
  Employers,
  Employees,
  EmployerHotline,
  EmployeeHotline,
  Website,
} from '../../constants/ContactInfo';
import ExternalLinks from '../../constants/ExternalLinks';
import ContactInfo from './ContactInfo/ContactInfo';
import Divider from '../Divider/Divider';
import AriaLink from '../AriaLink/AriaLink';
import LinkType from '../../constants/LinkType';
import './ContactUs.scss';

const ContactUs = (): JSX.Element => {
  return (
    <>
      <div className="section">
        <h1 data-testid="contact-us" className="margin-0 padding-bottom-1">
          Contact Us
        </h1>
        <p>
          Questions about E-Verify? We’re here to help. You can find answers to many common questions on our website at{' '}
          <AriaLink link={ExternalLinks.E_VERIFY} linkType={LinkType.WEB} customLinkText="www.e&#8209;verify.gov" />,
          and we’re always just a phone call or e-mail away if you need us.
        </p>
      </div>
      <div className="section">
        <h2>E-Verify Customer Support</h2>
        <p>
          E-Verify Customer Support is available to assist you with using E-Verify and managing cases. We can also
          answer your questions about E-Verify policies and procedures, Form I-9 and employment eligibility. We are
          available Monday through Friday, from 8 a.m. to 8 p.m. ET, except when the federal government is closed. For
          customers with hearing and speech impairment, TTY phone is available from 8:00 a.m. to 8:00 p.m. Eastern.
        </p>
        <div className="contact-info">
          <ContactInfo
            header={EmployerAgents.name}
            content={[EmployerAgents.phoneNumber, EmployerAgents.textNumber]}
            links={[EmployerAgents.emailAddress]}
          />
          <ContactInfo
            header={Employers.name}
            content={[Employers.phoneNumber, Employers.textNumber]}
            links={[Employers.emailAddress]}
          />
          <ContactInfo
            header={Employees.name}
            content={[Employees.phoneNumber, Employees.textNumber]}
            links={[Employees.emailAddress]}
          />
        </div>
        <p className="text-tip">* TTY: For hearing and speech impaired customers</p>
        <p>
          Our normal response time for e-mail inquiries is two business days. If we need more time to respond to your
          inquiry, we’ll contact you within two business days to explain why we need additional time and provide you
          with an estimated response time.
        </p>
      </div>
      <Divider />
      <div className="section">
        <h2>U.S. Department of Justice, Civil Rights Division, Immigrant and Employee Rights Section (IER)</h2>
        <p> IER is available to answer your questions about immigration or employment-related discrimination.</p>
        <div className="contact-info">
          <ContactInfo
            header={EmployerHotline.name}
            content={[EmployerHotline.phoneNumber, EmployerHotline.textNumber]}
          />
          <ContactInfo
            header={EmployeeHotline.name}
            content={[EmployeeHotline.phoneNumber, EmployeeHotline.textNumber]}
          />
          <ContactInfo header={Website.name} links={[Website.website]} />
        </div>
        <p className="text-tip">* TTY: For hearing and speech impaired customers</p>
      </div>
    </>
  );
};

export default ContactUs;
